import {DomainStore} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {endpoints, types, auth} from 'main/tools';
import {ExpenseRequest, Expense} from 'main/stores/expenses';
import {successAlert} from 'shared/tools';
import {t, formatCurrency} from 'shared/core';
import _ from 'lodash';

class EditExpenseState {
  store = new DomainStore();
  match;
  history;
  action;

  @observable request = new ExpenseRequest();
  @observable errors = {};

  receiveProps({match, history, action}) {
    this.match = match;
    this.history = history;
    this.action = action;
  }

  @action async load() {
    if (this.isEditing) {
      await this.store._compose([endpoints.EXPENSES.REQUEST.with(this.match.params.id)]);

      this.request = new ExpenseRequest(
        this.store._getSingle(types.EXPENSES.REQUEST, {id: this.match.params.id})
      );
    } else {
      this.request = new ExpenseRequest({expenses: [new Expense()]});
    }
  }

  @computed get isEditing() {
    return this.action === 'edit';
  }

  @computed get backPath() {
    return `/${this.match?.params?.backPath || ''}`;
  }

  @computed get backTitle() {
    return this.match?.params?.backPath === 'expense_requests' ?
      t('expenses.subnav.Expense Requests') :
      t('expenses.subnav.My Expenses');
  }

  @computed get total() {
    const summedExpenses = _.sumBy(this.request.expenses, expense => Number(expense.amount)) || 0;

    return formatCurrency('CAD', summedExpenses);
  }

  @action addExpense() {
    this.request.expenses.push(new Expense());
  }

  @action removeExpense(expense) {
    this.request.expenses.remove(expense);
  }

  @action updateCategory(expense, id, name) {
    expense.nmbrPresetId = id;
    expense.category = name;
  }

  @action async submit() {
    const {model, errors} = this.isEditing ?
      await this.store.patch(endpoints.EXPENSES.REQUEST.with(this.request.id), types.EXPENSES.REQUEST, this.request) :
      await this.store.post(endpoints.EXPENSES.REQUESTS.with(auth.employee.id), types.EXPENSES.REQUEST, this.request);

    this.errors = errors;

    if (model) {
      successAlert(this.isEditing ?
        t('expenses.edit.Expense request updated') :
        t('expenses.edit.Expense request submitted')
      );
      this.history.push(this.backPath);
    }
  }
}

export default EditExpenseState;
